"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetPortalReporter = exports.makePortalReporter = exports.ClickableContextProvider = exports.ClickableContextConsumer = exports.defaultClickableContext = void 0;

var _react = require("react");

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var defaultClickableContext = function defaultClickableContext() {};

exports.defaultClickableContext = defaultClickableContext;

var _createContext = (0, _react.createContext)(defaultClickableContext),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.ClickableContextProvider = Provider;
exports.ClickableContextConsumer = Consumer;
var hasReportedPortal = false;

var makePortalReporter = function makePortalReporter(getPortalReporterDetails) {
  return function (layerFor) {
    if (hasReportedPortal) return;

    var _getPortalReporterDet = getPortalReporterDetails(),
        componentName = _getPortalReporterDet.componentName,
        labelText = _getPortalReporterDet.labelText;

    var message = "A portal component (`" + layerFor + "`) was rendered in a `" + componentName + "`";
    message += labelText ? " labeled \"" + labelText + "\"." : '.';

    _devLogger.default.warn({
      message: message,
      url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6275',
      key: "portal-in-" + componentName
    });
  };
}; // For testing only


exports.makePortalReporter = makePortalReporter;

var resetPortalReporter = function resetPortalReporter() {
  hasReportedPortal = false;
};

exports.resetPortalReporter = resetPortalReporter;